import { render, staticRenderFns } from "./sousuodanxuan.vue?vue&type=template&id=bf917750&"
import script from "./sousuodanxuan.vue?vue&type=script&lang=ts&"
export * from "./sousuodanxuan.vue?vue&type=script&lang=ts&"
import style0 from "./sousuodanxuan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports